export default function createMiddleware({ getState }) {
    return next => action => {
        Raven.captureBreadcrumb({
            category: 'redux',
            message: action.type
        });

        return next(action);
    }
}